export interface ProductFetchParams {
    sku?: string;
    extId?: string;
    productId?: string;
    variantId?: string;
}

export enum ProductParams {
    sku = 'sku',
    extId = 'extId',
    externalId = 'externalId',
    productId = 'productId',
    variantId = 'variantId',
    product = 'product',
    metadata = 'metadata',
}
